<div
  class="loading-wrapper"
  [ngClass]="{ 'loading-wrapper--lightMode': lightMode }"
>
  @if (hasError) {
    <div class="loading-wrapper__errorContent">
      <article>
        <strong>{{ title | translate }}</strong>
        <p>{{ message | translate }}</p>
      </article>
      <commons-button
        [full]="true"
        [gray]="true"
        [rounded]="true"
        [buttonText]="'ui.try_again' | translate"
        (buttonClick)="onRetry()"
      >
      </commons-button>
    </div>
  } @else {
    <div class="loading-wrapper__awaitContent">
      <span class="loading-wrapper__awaitContent__message">{{
        'messages.wait_moment' | translate
      }}</span>
      <commons-loader></commons-loader>
    </div>
  }
</div>
